import React, { useState, useEffect } from "react";

import { Collapse } from "reactstrap";
import ImageWrapper from "components/ImageWrapper";
import InformationIcon from "components/icons/InformationIcon";
import ThreeDotsHorizontalIcon from "components/icons/ThreeDotsHorizontalIcon";
import ShareIcon from "components/icons/ShareIcon";
import SaleIcon from "components/icons/SaleIcon";

import { currencyFormat } from "sharedUtils/productUtils";
import { UncontrolledPopover, PopoverBody } from "reactstrap";

/**
 * 
 * @param {{product:object,edit:Function, toggleProductModal:Function, toggleShareModal:Function}} props
 */
const AllProductsRowMobile = (props) => {
    let [isOpen, setIsOpen] = useState(false);
    const [isAdded, setIsAdded] = useState(false);
    const [product, setProduct] = useState(props.product)

    useEffect(() => {
        if (props.addedProduct != null && props.addedProduct != undefined && props.addedProduct.merchantProductId === product.merchantProductId) {
            const updatedProduct = product;
            updatedProduct.shareCode = props.addedProduct.shareCode;
            updatedProduct.userMerchantProductId = props.product.userMerchantProductId;
            setProduct(updatedProduct);
        }

    }, [props.addedProduct]);

    let pstyle = { fontFamily: "Archivo", fontSize: "12px", width: "70%" }

    const handleAdd = async () => {
        setIsAdded(true);
        setIsOpen(!isOpen);
        await props.addProductToInventory(product.merchantProductId);
    }

    const handleShare = async () => {
        if (props.showAdd && !isAdded) {
            setIsAdded(true);
            await   props.addProductToInventory(product.merchantProductId, true);
        }

        props.toggleShareModal(product, props.isUserMerchant ? props.isUserMerchant : false);
    }

    return (
        <div className="card p-1">

            <div className="d-flex justify-content-between px-1">
                <ImageWrapper
                    className="mr-1"
                    src={product.imageUrl}
                    style={{ width: "30px", height: "30px" }}
                    onClick={props.toggleProductModal}
                />

                <p className="my-1" style={{ ...pstyle, display: "inline" }} onClick={props.toggleProductModal}>
                    {product.name}<span>{props.product.sale && !!(props.product.salePrice) ? <SaleIcon style={{ marginLeft: "3px" }} /> : ""}</span>
                </p>

                {/**/}
                <button className="btn btn-outline-light" onClick={() => setIsOpen(!isOpen)}>
                    <ThreeDotsHorizontalIcon />
                </button>

            </div>

            <Collapse isOpen={isOpen} className="pt-0">

                <p className="ml-1 mb-0" style={pstyle}>
                    <strong>Brand</strong>: {product.manufacturer}
                </p>

                <p className="ml-1 mb-0" style={pstyle}>
                    <strong>Merchant</strong>: {product.merchant}
                </p>

                <p className="ml-1 mb-0" style={pstyle}>
                    <strong>Price</strong>: {product.sale && !!(product.salePrice) ? <span className="mr-1">${product.salePrice.toFixed(2)}</span> : <></>} <span className={`${product.sale && !!(product.salePrice) ? "on-sale-price-single" : ""}`} style={{ paddingTop: product.sale && !!(product.salePrice) ? "2px" : "" }}>{currencyFormat(product.sale && !!(product.salePrice) && !!(product.originalPrice) ? product.originalPrice : product.price)}</span>
                </p>

                <p className="ml-1 mb-0" style={pstyle}>
                    <strong>Estimated Commission</strong>
                    <sup>*</sup>
                    : {currencyFormat(product.estimatedCommission)}
                </p>
                {props.showAdd && !isAdded ?
                    <button className="btn btn-secondary btn-sm mt-2 mx-1" onClick={handleAdd}>
                        Add
                    </button> :
                    <button className="btn btn-secondary btn-sm mt-2 mx-1" disabled>
                        Add
                    </button>
                }

                <button className="btn btn-outline-brand btn-sm mt-2 mx-1" onClick={handleShare}>
                    Share
                </button>

                <button className="btn btn-primary btn-sm mt-2" onClick={() => props.handleGetLink("https://" + window.location.host + "/prdlink/" + props.product.shareCode)}>
                    Get Link
                </button>
            </Collapse>
        </div>
    )
}

export default AllProductsRowMobile;